import React, {
  createContext,
  useReducer,
  useContext,
  useCallback,
} from 'react'

//
import { IProvider, IState, IDispatch, TAction } from './types'
import { reducer } from './reducer'
import { useAuth } from '../authContext'

const State = createContext<any>(null)
const Actions = createContext<any>(null)

export const useAuthUser = (): IState => useContext(State)
export const useAuthUserDispatch = (): IDispatch => useContext(Actions)

export const Provider = (props: IProvider): React.ReactElement => {
  const { uid } = useAuth()
  const { children, initialState = { currentUid: uid, isListening: false } } =
    props

  const [state, _dispatch] = useReducer(reducer, initialState)

  // Exposed dispatch function
  const dispatch: IDispatch = useCallback(
    (type: string, action?: any): void => {
      const _action = { type, ...action } as TAction
      _dispatch(_action)
    },
    [],
  )

  return (
    <State.Provider value={state}>
      <Actions.Provider value={dispatch}>{children}</Actions.Provider>
    </State.Provider>
  )
}
